var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroiconsOutlineSpeakerphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6655 14.2247V45.3933C25.6648 46.3604 25.3228 47.2963 24.6998 48.0359C24.0768 48.7756 23.2127 49.2717 22.2598 49.4368C21.3069 49.6019 20.3263 49.4254 19.4908 48.9384C18.6553 48.4514 18.0184 47.6852 17.6925 46.7747L12.6828 32.4247M12.6828 32.4247C10.7023 31.5826 9.07355 30.0845 8.07219 28.1796C7.07083 26.2746 6.75835 24.0823 7.18763 21.9734C7.61692 19.8646 8.7616 17.9689 10.428 16.607C12.0943 15.2451 14.18 14.5008 16.3321 14.5H20.6068C30.1735 14.5 38.3985 11.6207 41.9988 7.5V40.1667C38.3985 36.046 30.1758 33.1667 20.6068 33.1667H16.3321C15.0783 33.1677 13.8372 32.9138 12.6828 32.4247ZM41.9988 30.8333C43.8553 30.8333 45.6358 30.0958 46.9485 28.7831C48.2613 27.4703 48.9988 25.6898 48.9988 23.8333C48.9988 21.9768 48.2613 20.1963 46.9485 18.8836C45.6358 17.5708 43.8553 16.8333 41.9988 16.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroiconsOutlineSpeakerphone);
export default __webpack_public_path__ + "static/media/heroicons-outline_speakerphone.410d88f763f279ff405babd0561d2ead.svg";
export { ForwardRef as ReactComponent };